import gql from 'graphql-tag'

export const locationResultFragment = gql`
  fragment locationResult on LocationResult {
    id
    slug
    name
    cityName
    country {
      code
    }
  }
`
